import moment from 'moment';
import { useTranslation } from 'react-i18next';

type Result = (createdAt: Date) => string;

const useOrderTimeLabel = (): Result => {
  const { t } = useTranslation();

  return (createdAt: Date): string => {
    const hoursAgo = Math.abs(moment().diff(moment(createdAt), 'h'));

    return hoursAgo > 24
      ? t('recommendedOrderDaysAgo', { days: hoursAgo % 24 })
      : t('recommendedOrderHoursAgo', { hours: hoursAgo });
  };
};

export default useOrderTimeLabel;
